<template>
  <span
    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
    :class="badgeClasses"
    :title="`Difficulty: ${difficulty}`"
  >
    <span class="w-1.5 h-1.5 rounded-full mr-1.5" :class="dotClasses"></span>
    {{ difficulty }}
  </span>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  // Props
  interface Props {
    difficulty: 'beginner' | 'intermediate' | 'advanced'
  }

  const props = defineProps<Props>()

  // Computed
  const badgeClasses = computed(() => {
    const baseClasses = 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium'

    switch (props.difficulty) {
      case 'beginner':
        return `${baseClasses} bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200`
      case 'intermediate':
        return `${baseClasses} bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200`
      case 'advanced':
        return `${baseClasses} bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200`
      default:
        return `${baseClasses} bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200`
    }
  })

  const dotClasses = computed(() => {
    switch (props.difficulty) {
      case 'beginner':
        return 'bg-green-500 dark:bg-green-400'
      case 'intermediate':
        return 'bg-yellow-500 dark:bg-yellow-400'
      case 'advanced':
        return 'bg-red-500 dark:bg-red-400'
      default:
        return 'bg-gray-500 dark:bg-gray-400'
    }
  })
</script>
